import type { ResidentUploadedDocumentsListProps } from '../../types'
import { FileKindBadge } from '../../utils/fileKind'
import {
  formatResidentDocumentDate,
  getResidentDocumentsForType,
} from '../../utils/residentDocuments'



export function ResidentUploadedDocumentsList({
  documents,
  fileType,
  testIdPrefix,
  canRemove = false,
  processing = false,
  onDownload,
  onRemove,
}: ResidentUploadedDocumentsListProps) {
  const rows = getResidentDocumentsForType(documents, fileType)
  if (!rows.length) return null

  return (
    <div className="mt-2 w-full" data-testid={`${testIdPrefix}-uploaded-list`}>
      <p className="mb-2 text-sm font-semibold text-slate-700">
        Uploaded documents ({rows.length})
      </p>
      <div className="space-y-2">
      {rows.map((row, index) => {
        const key = String(row.attachment_id ?? `${fileType}-${index}`)
        const displayDate = formatResidentDocumentDate(row.filedate)
        return (
          <div
            key={key}
            className="flex w-full items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white p-3 shadow-sm transition-colors hover:border-slate-300"
            data-testid={`${testIdPrefix}-uploaded-row-${key}`}
          >
            <div className="flex min-w-0 flex-1 items-start gap-3">
              <FileKindBadge filename={row.filename || ''} className="mt-0.5" />
              <div className="min-w-0 flex-1">
                <button
                  type="button"
                  className="block w-full truncate text-left text-sm font-semibold text-slate-700 hover:text-sky-600 hover:underline disabled:cursor-not-allowed disabled:opacity-60"
                  disabled={processing || !row.filepath}
                  onClick={() =>
                    onDownload?.({
                      attachment_id: row.attachment_id,
                      filepath: row.filepath,
                      filename: row.filename,
                    })
                  }
                  title={row.filename}
                  data-testid={`${testIdPrefix}-uploaded-download-${key}`}
                >
                  {row.filename}
                </button>
                {displayDate ? (
                  <p className="mt-0.5 truncate text-xs text-slate-500">{displayDate}</p>
                ) : null}
              </div>
            </div>
            {canRemove && row.attachment_id ? (
              <button
                type="button"
                className="shrink-0 text-sm font-semibold text-red-600 transition hover:text-red-700 hover:underline disabled:cursor-not-allowed disabled:opacity-60"
                disabled={processing}
                onClick={() => onRemove?.(row.attachment_id as string | number)}
                title="Remove File"
                data-testid={`${testIdPrefix}-uploaded-remove-${key}`}
              >
                Remove
              </button>
            ) : null}
          </div>
        )
      })}
      </div>
    </div>
  )
}
